import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { TopNav } from './TopNav';
import { MobileNav } from './MobileNav';

export interface TopBarProps {
  activeTargetId?: string;
}

const SCROLL_REVEAL_PX = 70;

export function TopBar({ activeTargetId }: TopBarProps) {
  const theme = useTheme();
  const isLaptop = useMediaQuery(theme.breakpoints.up('laptop'));
  const { nav } = conventionContent;
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (isLaptop) return;
    const onScroll = () => setScrolled(window.scrollY > SCROLL_REVEAL_PX);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isLaptop]);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        width: '100%',
        backgroundColor: 'primary.main',
      }}
    >
      {isLaptop ? <TopNav activeTargetId={activeTargetId} /> : <MobileNav />}
      {!isLaptop && (
        <Box
          component='img'
          src={nav.mobileLogoSrc}
          alt=''
          aria-hidden='true'
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            height: pxToRem(30),
            width: 'auto',
            display: 'block',
            pointerEvents: 'none',
            opacity: scrolled ? 1 : 0,
            transition: 'opacity 200ms ease',
            '@media (prefers-reduced-motion: reduce)': {
              transition: 'none',
            },
          }}
        />
      )}
    </Box>
  );
}
